import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "simple-business-table" }
const _hoisted_2 = { class: "table-container" }
const _hoisted_3 = { class: "body-container" }
const _hoisted_4 = {
  key: 0,
  class: "item-container"
}

import { i18n } from '@/i18n';
import { businessContentName } from '@/appLogic/business/businessTableHeaders';
import TableCell from '@/components/atom/TableCell.vue';
import TableHead from '@/components/atom/TableHead.vue';
import { nullOrUndefinedToMinusOne } from '@/coreDomainsModule/extends/number';
import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { TableType } from '@/coreDomainsModule/table';
import { TableCommonViewModel, TableContentViewModel } from '@/viewModels/tableContent';
import SelectTableCell from './SelectTableCell.vue';
import { inject, onMounted, watch } from 'vue';
import { OrganizationBusinessRepository } from '@/businessRepository/organizationBusinessRepository';
import { useRoute } from 'vue-router';
import { useSelectedBusinessStore } from '../pages/selectedBusinessStore';
import { storeToRefs } from 'pinia';
import { TableContentFontSize } from '@/corePagesModule/BaseTableContent/interface/tableContentItems';
import { TableHeaderFontSize } from '@/corePagesModule/BaseTableContent/interface/tableContentHeaders';
import SelectInput from '@/corePagesModule/SelectInput';
import { key, useRecommendOrderStore } from '../pages/useRecommendOrderStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectableSimpleTableContent',
  props: {
    tableType: {},
    business: {},
    scrollEnable: { type: Boolean, default: false },
    editableLeadTime: { type: Boolean, default: false },
    editableStdInventory: { type: Boolean, default: false },
    tableHeadFontSize: { default: 'fontSizeS' },
    tableBodyFontSize: { default: 'fontSizeSS' }
  },
  emits: ["onClickLeadTimeButton", "onClickStdInventoryButton"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "e6b54c84": (props.scrollEnable ? `scroll` : `hidden`)
}))

const route = useRoute();
const organizationBusinessRepository = new OrganizationBusinessRepository();

// props
const props = __props;

// emits
const emits = __emit;

//変数
const t = i18n.t;
const commonTableContentVm = new TableCommonViewModel();
const vm = new TableContentViewModel();

const selectedBusinessStore = useSelectedBusinessStore();
const { fetchState, updateSelectedBusinessId } = selectedBusinessStore;
const { state } = storeToRefs(selectedBusinessStore);
const recommendOrderStore = inject(key);
if (!recommendOrderStore) {
  throw new Error('store is undefined');
}

// イベントフック
onMounted(async () => {
  await fetchState(organizationBusinessRepository, props.business);
});

watch(
  () => props.business,
  async (newValue) => {
    await fetchState(organizationBusinessRepository, newValue);
  },
  {
    deep: true,
  }
);

watch(
  state.value.selectValue,
  (newValue) => {
    // マッチするビジネスを取得
    updateSelectedBusinessId(newValue);
  },
  {
    deep: true,
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(commonTableContentVm).displayHeaders[_ctx.tableType], (property, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (
                (_unref(commonTableContentVm).mvpSimpleTableDisplayContents(property) && property !== 'MOQ' && property !== 'inventory') ||
                _unref(commonTableContentVm).commonTableDisplayContents(property) ||
                property === 'stdInventoryIndex'
              )
                ? (_openBlock(), _createBlock(TableHead, {
                    key: 0,
                    "font-size": props.tableHeadFontSize,
                    label: _unref(businessContentName)[property],
                    "text-align": 'left',
                    scope: "col"
                  }, null, 8, ["font-size", "label"]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", _hoisted_3, [
        (_ctx.business)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(commonTableContentVm).displayHeaders[_ctx.tableType], (property, propertyIndex) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: propertyIndex }, [
                  (property === 'warehouse')
                    ? (_openBlock(), _createBlock(TableCell, {
                        key: 0,
                        "font-size": props.tableBodyFontSize,
                        "text-align": 'left'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(SelectInput), {
                            "model-value": _unref(recommendOrderStore).state.selectedInfo.warehouse ?? '',
                            index: 1,
                            placeholder: _unref(t)('置場名'),
                            "prop-aggregate-business-filter-property": _unref(recommendOrderStore).state.selectedInfo,
                            label: '',
                            "filter-type": 'WAREHOUSE',
                            "is-open-prop": _unref(recommendOrderStore).state.isOpenFilterType === 'WAREHOUSE',
                            "use-teleport": "",
                            "onClick:selectInput": _cache[0] || (_cache[0] = () => (_unref(recommendOrderStore).state.isOpenFilterType = 'WAREHOUSE')),
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_unref(recommendOrderStore).updateSelectedInfo($event, undefined, undefined, undefined, undefined)))
                          }, null, 8, ["model-value", "placeholder", "prop-aggregate-business-filter-property", "is-open-prop"])
                        ], undefined, true),
                        _: 1
                      }, 8, ["font-size"]))
                    : (property === 'supplierName')
                      ? (_openBlock(), _createBlock(TableCell, {
                          key: 1,
                          "font-size": props.tableBodyFontSize,
                          "text-align": 'left'
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(SelectInput), {
                              "model-value": _unref(recommendOrderStore).state.selectedInfo.supplierName ?? '',
                              index: 2,
                              placeholder: _unref(t)('仕入先'),
                              "prop-aggregate-business-filter-property": _unref(recommendOrderStore).state.selectedInfo,
                              label: '',
                              "filter-type": 'SUPPLIER_NAME',
                              "is-open-prop": _unref(recommendOrderStore).state.isOpenFilterType === 'SUPPLIER_NAME',
                              "use-teleport": "",
                              "onClick:selectInput": _cache[2] || (_cache[2] = () => (_unref(recommendOrderStore).state.isOpenFilterType = 'SUPPLIER_NAME')),
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_unref(recommendOrderStore).updateSelectedInfo(undefined, $event, undefined, undefined, undefined)))
                            }, null, 8, ["model-value", "placeholder", "prop-aggregate-business-filter-property", "is-open-prop"])
                          ], undefined, true),
                          _: 1
                        }, 8, ["font-size"]))
                      : (property === 'businessNumber')
                        ? (_openBlock(), _createBlock(TableCell, {
                            key: 2,
                            "font-size": props.tableBodyFontSize,
                            "text-align": 'left'
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(SelectInput), {
                                "model-value": _unref(recommendOrderStore).state.selectedInfo.businessCode?.toString() ?? '',
                                index: 3,
                                placeholder: _unref(t)('商品CD'),
                                "prop-aggregate-business-filter-property": _unref(recommendOrderStore).state.selectedInfo,
                                label: '',
                                "filter-type": 'BUSINESS_CODE',
                                "is-open-prop": _unref(recommendOrderStore).state.isOpenFilterType === 'BUSINESS_CODE',
                                "use-teleport": "",
                                "onClick:selectInput": _cache[4] || (_cache[4] = () => (_unref(recommendOrderStore).state.isOpenFilterType = 'BUSINESS_CODE')),
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_unref(recommendOrderStore).updateSelectedInfo(undefined, undefined, $event, undefined, undefined)))
                              }, null, 8, ["model-value", "placeholder", "prop-aggregate-business-filter-property", "is-open-prop"])
                            ], undefined, true),
                            _: 1
                          }, 8, ["font-size"]))
                        : (property === 'businessName')
                          ? (_openBlock(), _createBlock(TableCell, {
                              key: 3,
                              "font-size": props.tableBodyFontSize,
                              "text-align": 'left'
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(SelectInput), {
                                  "model-value": _unref(recommendOrderStore).state.selectedInfo.businessName ?? '',
                                  index: 4,
                                  placeholder: _unref(t)('商品'),
                                  "prop-aggregate-business-filter-property": _unref(recommendOrderStore).state.selectedInfo,
                                  label: '',
                                  "filter-type": 'BUSINESS_NAME',
                                  "is-open-prop": _unref(recommendOrderStore).state.isOpenFilterType === 'BUSINESS_NAME',
                                  "use-teleport": "",
                                  "onClick:selectInput": _cache[6] || (_cache[6] = () => (_unref(recommendOrderStore).state.isOpenFilterType = 'BUSINESS_NAME')),
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_unref(recommendOrderStore).updateSelectedInfo(undefined, undefined, undefined, $event, undefined)))
                                }, null, 8, ["model-value", "placeholder", "prop-aggregate-business-filter-property", "is-open-prop"])
                              ], undefined, true),
                              _: 1
                            }, 8, ["font-size"]))
                          : (property === 'package')
                            ? (_openBlock(), _createBlock(TableCell, {
                                key: 4,
                                "font-size": props.tableBodyFontSize,
                                "row-value": _unref(vm).getDisplayValue(_ctx.business[property], property),
                                "text-align": 'center'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(SelectInput), {
                                    "model-value": _unref(recommendOrderStore).state.selectedInfo.packageAmount?.toString() ?? '',
                                    index: 5,
                                    placeholder: _unref(t)('容量'),
                                    "prop-aggregate-business-filter-property": _unref(recommendOrderStore).state.selectedInfo,
                                    label: '',
                                    "filter-type": 'PACKAGE_AMOUNT',
                                    "is-open-prop": _unref(recommendOrderStore).state.isOpenFilterType === 'PACKAGE_AMOUNT',
                                    "use-teleport": "",
                                    "onClick:selectInput": _cache[8] || (_cache[8] = () => (_unref(recommendOrderStore).state.isOpenFilterType = 'PACKAGE_AMOUNT')),
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_unref(recommendOrderStore).updateSelectedInfo(undefined, undefined, undefined, undefined, $event)))
                                  }, null, 8, ["model-value", "placeholder", "prop-aggregate-business-filter-property", "is-open-prop"])
                                ], undefined, true),
                                _: 2
                              }, 1032, ["font-size", "row-value"]))
                            : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})